var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.badgeClasses},[(_vm.hasIcon)?_c('span',{staticClass:"tagIcon"}):_vm._e(),_vm._v(" "),(_vm.labelComputed)?_c('span',[_vm._v(_vm._s(_vm.labelComputed))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }